/* ラベル表示なしテキストエリア */
import React, { memo } from 'react';
import { FormControl } from 'react-bootstrap';
import Messages from '../molecules/Messages';
import { convertLine, calcRow } from '../Convert';

interface Props {
  id: string;
  fm_id?: number;
  value: string;
  placeholder?: string;
  handleChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  help_msg?: string;
  message?: string;
  name: string;
  rows?: number;
  disabled: boolean;
  handleBlur?: VoidFunction;
  maxlength?: number;
}

const NoLabelTextarea: React.FC<Props> = ({
  id,
  fm_id,
  value,
  placeholder,
  handleChange,
  help_msg,
  message,
  name,
  rows,
  disabled,
  handleBlur,
  maxlength,
}) => {
  return disabled ? (
    <div className="paragraph">{convertLine(value)}</div>
  ) : (
    <>
      <FormControl
        id={id}
        data-fm_id={fm_id}
        as="textarea"
        rows={rows ? rows : calcRow(value)}
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        name={name}
        disabled={disabled}
        onBlur={handleBlur}
        maxLength={maxlength}
      />
      {disabled || <Messages help_msg={help_msg} valid_msg={message} />}
    </>
  );
};

export default memo(NoLabelTextarea);
